import { ChildAge } from './ChildrenAgePicker'

export const UNSELECTED_CHILD_AGE = -1

export const updateAgeOfChild = (
  childrenAges: ChildAge[],
  childToAdd: ChildAge,
  indexToReplace: number
): ChildAge[] => [
  ...childrenAges.slice(0, indexToReplace - 1),
  childToAdd,
  ...childrenAges.slice(indexToReplace),
]

export const updateChildrenAges = (
  childrenAges: ChildAge[] | undefined,
  numChildren: number,
  defaultAge = 0
): ChildAge[] | undefined => {
  // Updates number of objects in array - setChildAge updates the value within the objects

  // If 0 children - reset
  if (!numChildren) {
    return undefined
  }

  // First children added but array does not exist, create with default value
  if (!childrenAges) {
    return Array.from({ length: numChildren }, (_, i) => ({
      child: `child_${i + 1}`,
      age: defaultAge,
    }))
  }

  // Add children to array with default value
  if (childrenAges.length < numChildren) {
    const missing = numChildren - childrenAges.length

    const newChildren = Array.from({ length: missing }, (_, i) => ({
      child: `child_${childrenAges.length + i + 1}`,
      age: defaultAge,
    }))

    return [...childrenAges, ...newChildren]
  }

  //  If number of children decreased, remove extra from end of array
  if (childrenAges.length > numChildren) {
    return childrenAges.slice(0, numChildren)
  }

  return childrenAges
}
